<div class="avia-fly">
  <div class="avia-fly-item">
    <div class="avia-fly__destination">
      <div class="item from">
        <span class="time">{{ leg.departureTime | time }}</span>
        <span class="airport-code">{{ leg.origin.airport.iataCode }}</span>
      </div>
      <span class="destination-separator"></span>
      <div class="item to">
        <span class="airport-code">{{ leg.destination.airport.iataCode }}</span>
        <span class="time">{{ leg.arrivalTime | time }}</span>
        @if (leg.timeDeltaInDays > 0) {
          <span class="on-way">+{{ leg.timeDeltaInDays }}д</span>
        }
      </div>
    </div>
    <div class="avia-fly__info">
      <span class="duration">{{ translations.onWay }} {{ this.leg.durationInMinutes | durationPipe }}</span>
      <span>{{ stopovers }}</span>
    </div>
  </div>

  <div class="avia-fly__airline many">
    @for (segment of uniqueSegments; track segment.airline.iataCode) {
      <object [attr.data]="getAirlineLogo(segment.airline.iataCode)" type="image/png">
        <img src="/x-assets/img/icons/no-airline-logo.svg" alt="airline-logo">
      </object>
    }
  </div>
</div>
